
import React from 'react';
import { GoogleAuthButton } from './GoogleAuthButton';
import { logWithTimestamp } from '../utils/authUtils';
import { getValidUserTypes } from '../utils/userTypeUtils';

interface SocialAuthProps {
  className?: string;
  userType?: string;
  onStart?: () => void;
  onError?: (error: Error) => void;
}

export const SocialAuth = ({ 
  className = "", 
  userType = "standard",
  onStart, 
  onError 
}: SocialAuthProps) => {
  const handleAuthStart = async () => {
    logWithTimestamp('Social authentication flow started');
    
    // Validate user type before starting auth flow
    try {
      const validTypes = await getValidUserTypes();
      if (!validTypes.includes(userType)) {
        logWithTimestamp(`Invalid user type ${userType}, defaulting to standard`);
        userType = "standard";
      }
    } catch (err) {
      // If validation fails, use standard as fallback
      logWithTimestamp('Error validating user type, using standard', err);
      userType = "standard";
    }
    
    if (onStart) onStart();
  };

  const handleError = (error: Error) => {
    logWithTimestamp('Social authentication error:', error);
    if (onError) onError(error);
  };

  return (
    <div className={`mt-6 space-y-4 ${className}`}>
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-white/10"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 text-gray-400 bg-gray-800">or continue with</span>
        </div>
      </div>
      
      <GoogleAuthButton 
        userType={userType}
        onSignInStart={handleAuthStart}
        onSignInError={handleError}
      />
    </div>
  );
};
